import { getBottomPadding, getTopPadding } from '../../../utils/sessionStorage'
import BackButton from '../../ui-components/BackButton'
import { useNavigate } from 'react-router-dom'
import RenderHTML from '../../ui-components/RenderHTML'
import { trackEvent } from '../../../utils/appBridge'
import { EventNames } from '../../../types/misc.types'
import { useEffect } from 'react'
import { TerminalStatusContext } from '../../../types/mf-execution.types'

type AwaitingProps = {
  title: string
  timerText: string
  subtitle?: string
  caption?: string
  onBackButtonClick?: () => void
  statusContext?: TerminalStatusContext
}

export const Awaiting = ({
  title,
  subtitle,
  timerText,
  caption,
  onBackButtonClick,
  statusContext
}: AwaitingProps) => {
  const navigate = useNavigate()

  const getScreenName = () => {
    switch (statusContext) {
      case TerminalStatusContext.AUTO_PAY:
        return 'Autopay_setup_awaiting'
      default:
        return 'Payment awaiting'
    }
  }

  useEffect(() => {
    trackEvent({
      eventName: EventNames.ScreenLoaded,
      payload: {
        ScreenName: getScreenName(),
        eventId: `${statusContext}`
      }
    })
  }, [statusContext])

  const handleBackClick = () => {
    if (onBackButtonClick) {
      onBackButtonClick()
    } else {
      navigate(-1)
    }
  }

  return (
    <div
      style={{ paddingBottom: `calc(${getBottomPadding()}px + 8px)` }}
      className='flex flex-col h-full w-full bg-white relative'
    >
      {/* Back Button */}
      {onBackButtonClick && (
        <div style={{ top: `${getTopPadding() + 12}px` }} className='absolute left-5 z-10'>
          <BackButton onClick={handleBackClick} />
        </div>
      )}

      {/* Main Content */}
      <div className='flex flex-col h-full w-full px-5 pt-[35vh]'>
        {/* Countdown Timer */}
        <div className='text-[34px] font-[500] text-[#1470CC] leading-[100%] text-left mb-[22px]'>
          {timerText}
        </div>

        {/* Title/Instructions */}
        <div className='text-[22px] font-[500] text-[#232323] leading-[150%] text-left pr-5 mb-4'>
          <RenderHTML innerHTMLText={title} />
        </div>
        {subtitle && (
          <div className='text-[14px] font-[400] text-[#6A6E6E] leading-[160%] text-left mb-4'>
            <RenderHTML innerHTMLText={subtitle} />
          </div>
        )}

        {/* Warning Message */}
        {caption && (
          <div className='text-[14px] font-[400] text-[#6A6E6E] leading-[160%] text-center mt-auto mb-4'>
            <RenderHTML innerHTMLText={caption} />
          </div>
        )}
      </div>
    </div>
  )
}
